import React, { useState } from "react";

const FollowersModal = ({ filters, setFilters, onClose }) => {
  const { min, max } = filters.followers || { min: 0, max: 100000000 };

  const [tempMax, setTempMax] = useState(max);

  const applyChange = () => {
    setFilters({
      ...filters,
      followers: { ...(filters.followers || {}), max: tempMax }
    });
  };

  return (
    <div className="w-full relative">
      {/* Arrow Pointer */}
      <div className="absolute -top-5 left-10 w-4 h-4 bg-white rotate-45 border-l border-t"></div>
      <h2 className="lg:text-xl text-lg font-semibold mb-4">Followers</h2>

      <div className="flex justify-between">
        <div>
          <p className="text-gray-500">Min</p>
          <p className="lg:text-2xl text-xl">{min}</p>
        </div>

        <div>
          <p className="text-gray-500">Max</p>
          <p className="lg:text-2xl text-xl">{tempMax.toLocaleString()}+</p>
        </div>
      </div>

      <input
        type="range"
        min={0}
        max={100000000}
        value={tempMax}
        onChange={(e) => setTempMax(+e.target.value)}
        onMouseUp={applyChange}
        onTouchEnd={applyChange}
        className="w-full"
      />

      <div className="flex justify-between gap-6 mt-4">
        <button
          onClick={() => {
            setTempMax(100000000);
            setFilters({
              ...filters,
              followers: { min: 0, max: 100000000 }
            });
            onClose();
          }}
          className="underline text-sm text-gray-700 hover:text-gray-900"
        >
          Clear
        </button>

        <button
          onClick={() => {
            applyChange();
            onClose();
          }}
          className="flex flex-row bg-orange-500 text-white lg:py-2 py-2 px-8 rounded-xl lg:text-base text-sm"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default FollowersModal;